var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanksupportIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 108,
    viewBox: "0 0 107 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5018_10546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 107,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.942 0.558594H0.0576172V107.443H106.942V0.558594Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5018_10546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5001 5.02344C80.5316 5.02344 102.479 26.9709 102.479 54.0023C102.479 81.0338 80.5316 102.981 53.5001 102.981C26.4687 102.981 4.52124 81.0338 4.52124 54.0023C4.52124 26.9709 26.4687 5.02344 53.5001 5.02344Z",
    stroke: "#FF883A",
    strokeWidth: 5.69522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 22.5293V66.7677",
    stroke: "#FF883A",
    strokeWidth: 5.93804,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5002 77.7539C55.5693 77.7539 57.2492 79.4338 57.2492 81.5029C57.2492 83.5719 55.5693 85.2519 53.5002 85.2519C51.4311 85.2519 49.7512 83.5719 49.7512 81.5029C49.7512 79.4338 51.4311 77.7539 53.5002 77.7539Z",
    fill: "#E8650E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanksupportIco);
export default __webpack_public_path__ + "static/media/banksupportIco.fa9b5e831c2916c8b0aa44c8a8d9eedc.svg";
export { ForwardRef as ReactComponent };